module.exports = __webpack_public_path__ + "img/oalogo.7d78b01b.jpg";